import React, { useState, useRef, useEffect } from "react";
import "./Test.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { END_URL } from "../../config";
import axios from "axios";
import dum from "../../images/modal1.png";
import { IMG_URL } from "../../config";
import banner1 from "../../images/asm-banner.jpg";
import gg from "../../images/pp-logo.gif";

const TestDetail = ({
  testItem,
  handleResults,
  startindex,
  BannerImage,
  currentindex,
  processCount,
  onNavHide,
  TestColor,
  slug,
  dimension_groups,
  TestIntro,
}) => {
  const [activeIndex, setActiveIndex] = useState(startindex);
  const [editingIndex, setEditingIndex] = useState(null);
  const [sliderValues, setSliderValues] = useState([]);
  const sliderRefs = useRef([]);
  const isDragging = useRef(false);
  const [TestData, setTestData] = useState({});
  const [paddLeft, SetPaddLeft] = useState(true);
  const [banner, setBanner] = useState(null);
  const [loadingBanner, setLoadingBanner] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const progressPercentages =
    dimension_groups?.length > 0 ? dimension_groups[0].percentages || [] : [];

  // const steps = Array.from({ length: processCount || 6 }, (_, i) => i + 1);

  const steps =
    progressPercentages.length > 0
      ? progressPercentages
      : Array.from({ length: processCount || 6 }, (_, i) => i + 1);

  useEffect(() => {
    if (testItem) {
      const TestCategory = testItem?.questions?.map((data) => ({
        ...data,
        value: data.value || 50,
        result: data.result || 0,
        specialquestions: data.specialquestions || "N",
        required: data.required || false,
        letter: data.letter || null,
        left_result: data.left_result || 0,
        right_result: data.right_result || 0,
        answered: data.answered || false,
      }));

      setSliderValues(new Array(TestCategory.length).fill(50));

      const newTestData = {
        ...testItem,
        questions: TestCategory,
      };

      setTestData(newTestData);
      handleResults(newTestData);
      setActiveIndex(startindex);

      setTimeout(() => {
        const sections = document.getElementsByClassName("banner-top");
        if (sections[startindex]) {
          const nextSectionTop =
            sections[startindex].getBoundingClientRect().top +
            window.scrollY -
            80;
          window.scrollTo({ top: nextSectionTop, behavior: "smooth" });
        }
      }, 0);
    }
  }, [testItem]);

  // useEffect(() => {
  //   const fetchBanner = async () => {
  //     try {
  //       if (!testItem?.slug) return;
  //       const res = await axios.get(`${END_URL}/starter_quiz_banner/${slug}`);
  //       setBanner(res.data?.starter_quiz_banner?.starter_quiz_banner || null);
  //     } catch (err) {
  //       console.error("Error fetching banner:", err);
  //     } finally {
  //       setLoadingBanner(false);
  //     }
  //   };

  //   fetchBanner();
  // }, [testItem]);

  // useEffect(() => {
  //   if (!loadingBanner) {
  //     const timer = setTimeout(() => setShowLoader(false), 500);
  //     return () => clearTimeout(timer);
  //   }
  // }, [loadingBanner]);

  useEffect(() => {
    if (BannerImage) {
      setShowLoader(false);
    }
  }, [BannerImage]);

  const handleStartDrag = (e, index) => {
    e.preventDefault();
    setEditingIndex(index);
    isDragging.current = true;

    const moveHandler = (e) => {
      let clientX;
      if (e.type.startsWith("touch")) {
        clientX = e.touches[0].clientX;
      } else {
        clientX = e.clientX;
      }

      const sliderRef = sliderRefs.current[index];
      if (!sliderRef) return;

      const rect = sliderRef.getBoundingClientRect();
      let newX = clientX - rect.left;
      let percent = (newX / rect.width) * 100;

      percent = Math.max(0, Math.min(100, percent));

      const result = percent < 50 ? -(100 - percent * 2) : (percent - 50) * 2;

      setTestData((prevTestData) => {
        const updatedQuestions = prevTestData?.questions?.map((q, idx) => {
          if (idx === index) {
            return { ...q, value: percent, result, answered: true };
          }
          return q;
        });

        const updatedTestData = {
          ...prevTestData,
          questions: updatedQuestions,
        };
        handleResults(updatedTestData);
        return updatedTestData;
      });
    };

    const endHandler = () => {
      isDragging.current = false;

      document.removeEventListener("mousemove", moveHandler);
      document.removeEventListener("mouseup", endHandler);
      document.removeEventListener("touchmove", moveHandler);
      document.removeEventListener("touchend", endHandler);

      if (index !== null && activeIndex < sliderValues.length - 1) {
        const newIndex = index + 1;
        setActiveIndex(newIndex);
        setSliderValues((prevValues) => {
          const newValues = [...prevValues];
          newValues[newIndex] = newValues[newIndex] ?? 70;
          return newValues;
        });

        setTimeout(() => {
          const sections = document.getElementsByClassName("test-box1");
          if (sections[newIndex]) {
            const nextSectionTop =
              sections[newIndex].getBoundingClientRect().top +
              window.scrollY -
              100;
            window.scrollTo({ top: nextSectionTop, behavior: "smooth" });
          }
        }, 0);
      }
    };

    document.addEventListener("mousemove", moveHandler);
    document.addEventListener("mouseup", endHandler);
    document.addEventListener("touchmove", moveHandler, { passive: false });
    document.addEventListener("touchend", endHandler);
  };

  const [scrolledPast, setScrolledPast] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const containerBottom = container.offsetTop + container.offsetHeight;
      const scrollY = window.scrollY + 170;

      setScrolledPast(scrollY > containerBottom);
      onNavHide(scrollY > containerBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (showLoader) {
    return (
      <div className="loadingDiv">
        <img src={gg} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      {BannerImage && (
        <div className="test-banner banner-top">
          <div
            className="container-fluid test-content-imgDiv"
            ref={containerRef}
          >
            <div className="row">
              <div
                className="test-all-cont"
                style={{
                  background: `url(${IMG_URL}/d0/${BannerImage}) no-repeat center center`,
                  backgroundSize: "cover",
                }}
              >
                <div className="test-all-img"></div>
                <div
                  className="test-content-outer1"
                  dangerouslySetInnerHTML={{
                    __html: testItem.longdescription,
                  }}
                />
              </div>
              <div className="test-page-float-box">

                    <div className="intro-test-content-outer" 
                       style={{
                          "--content-outer": `${TestIntro?.note_color}`,
                        }}
                    >

                            <span> <img src={`${IMG_URL}/d0/${TestIntro?.test_note_image}`} /> </span>
                            
                            <div
                                  className="intro-test-content"
                                  dangerouslySetInnerHTML={{
                                    __html: TestIntro?.test_intro_note,
                              }}
                            />

                    </div>

                  <div className="scoll-fixed-outer">
                    <div
                      className={`test-mark-outer ${
                        scrolledPast ? "scrolled-class" : ""
                      }`}
                    >
                      {/* <div className="intro-test-content-outer">

                            <span> <img src={dum} /> </span>
                            
                            <div
                                  className="intro-test-content"
                                  dangerouslySetInnerHTML={{
                                    __html: TestIntro,
                              }}
                            />

                        </div> */}

                      <div className="test-mark image-banner-test"  

                        style={{
                          "--leftColorLightMark": `${TestColor?.progress_left_color_1}66`,
                          "--rightColorLightMark": `${TestColor?.progess_right_color_1}66`,
                        }}
                        >

                        <ul 
                          style={{
                            "--leftColor": `${TestColor?.progress_left_color_1}`,
                            "--rightColor": `${TestColor?.progess_right_color_1}`,
                            "--leftColorLine": `${TestColor?.progress_left_color_1}99`,
                            "--rightColorLine": `${TestColor?.progess_right_color_1}99`,
                          }}
                        >
                          {steps.map((step, index) => (
                            <li
                              style={{
                              "--leftColorLight": `${TestColor?.progress_left_color_1}a3`,
                              "--rightColorLight": `${TestColor?.progess_right_color_1}c0`,
                              "--leftColorLight1": `${TestColor?.progress_left_color_1}c4`,
                              "--rightColorLight1": `${TestColor?.progess_right_color_1}e0`,
                              "--leftColorLight2": `${TestColor?.progress_left_color_1}66`,
                              "--rightColorLight2": `${TestColor?.progess_right_color_1}fa`,
                              "--leftColor": `${TestColor?.progress_left_color_1}`,
                              "--rightColor": `${TestColor?.progess_right_color_1}`,
                            }}

                              key={index}
                              className={index <= currentindex ? "true-check" : ""}
                            >
                              <span
                                 style={{
                                  "--leftColor": `${TestColor?.progress_left_color_1}`,
                                  "--leftColorspan": `${TestColor?.progress_left_color_1}3a`,
                                  "--leftColorspan1": `${TestColor?.progress_left_color_1}6e`,
                                  "--leftColorspan2": `${TestColor?.progress_left_color_1}d0`,
                                  "--rightColor": `${TestColor?.progess_right_color_1}`,
                                  "--rightColorspan": `${TestColor?.progess_right_color_1}c0`,
                                  "--rightColorspan1": `${TestColor?.progess_right_color_1}e0`,
                                  "--rightColorspan2": `${TestColor?.progess_right_color_1}fa`,
                                }}
                              > 
                                {progressPercentages.length > 0 ? `${step}%` : step}
                              </span>

                              <span></span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
              </div>

            </div>
          </div>
        </div>
      )}

      <div className="container">
        {!BannerImage && (
          <div className="row test-title-row test-title-row-not-banner banner-top">
            <div className="test-title">
              <div
                className={
                  paddLeft ? "test-content-outer" : "test-content-outer-right"
                }
                dangerouslySetInnerHTML={{
                  __html: testItem.longdescription,
                }}
              />
            </div>

            <div className="test-mark-outer">
              <div className="test-mark">
                <ul>
                  {steps.map((step, index) => (
                    <li
                      key={step}
                      className={index <= currentindex ? "true-check" : ""}
                    >
                      <span>{step}</span>
                      <span></span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="row test-progress-row">
          <div className="col-12">
            <div className="test-progress-col position-relative w-100 mx-auto">
              {TestData?.questions
                ?.filter((q) => q.specialquestions === "N")
                .map((value, index) => {
                  const sliderValue = value.value ?? 50;
                  const percentFromCenter =
                    sliderValue >= 50
                      ? (sliderValue - 50) * 2
                      : (50 - sliderValue) * 2;

                  const dynamicColor =
                    sliderValue === 50
                      ? "#7e9ead"
                      : sliderValue < 50
                        ? TestColor?.left_color_1 || "#69bd8f"
                        : TestColor?.right_color_1 || "#ffb3ff";

                  return (
                    <div
                      key={index}
                      className="test-box1"
                      style={{
                        opacity:
                          index === 0 || value.answered || index <= activeIndex
                            ? 1
                            : 0.3,
                        pointerEvents:
                          index === 0 || value.answered || index <= activeIndex
                            ? "auto"
                            : "none",
                        transition:
                          "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                      }}
                      onMouseEnter={() => setEditingIndex(index)}
                      onMouseLeave={() => setEditingIndex(null)}
                      onTouchStart={() => setEditingIndex(index)}
                      onTouchEnd={() => setEditingIndex(null)}
                    >
                      <div className="test-t3-p">
                        <p>{value.question}</p>
                      </div>

                      <div className="test-content-div">
                        <div
                          className="test-content-one"
                          dangerouslySetInnerHTML={{ __html: value.option_1 }}
                          style={{
                            border: "2px solid transparent",
                            background: `
                                    linear-gradient(#fff, #fff) padding-box,
                                    linear-gradient(180deg, ${TestColor?.left_color_1}, #7e9ead) border-box
                                  `,
                            borderRadius: "12px",
                          }}
                        />

                        <div
                          className="test-content-two"
                          dangerouslySetInnerHTML={{ __html: value.option_2 }}
                          style={{
                            border: "2px solid transparent",
                            background: `
                                        linear-gradient(#fff, #fff) padding-box,
                                        linear-gradient(180deg, ${TestColor?.right_color_1}, #7e9ead) border-box
                                      `,
                            borderRadius: "12px",
                          }}
                        />
                      </div>

                      <div className="test-progress-bar">
                        <div className="test-progress-bar-inner position-relative w-100 mx-auto">
                          <div
                            className="test-cover-bar-div bg-light rounded-pill position-relative w-100 overflow-visible"
                            ref={(el) => (sliderRefs.current[index] = el)}
                          >
                            <div
                              className="test-color-part position-absolute top-0 h-100"
                              style={{
                                width: "100%",
                                background: `linear-gradient(to right, 
                                  ${
                                    TestColor?.left_color_1 ||
                                    "rgb(105, 189, 143)"
                                  } 0%, 
                                  ${
                                    TestColor?.left_color_2 ||
                                    "rgb(234, 255, 233)"
                                  } 50%, 
                                  ${
                                    TestColor?.right_color_2 ||
                                    "rgb(255, 233, 255)"
                                  } 50%, 
                                  ${
                                    TestColor?.right_color_1 ||
                                    "rgb(255, 179, 255)"
                                  } 100%)`,
                              }}
                            ></div>

                            <div
                              className="test-scroll-part position-absolute shadow-sm rounded-circle"
                              style={{
                                left: `${sliderValue}%`,
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "22px",
                                height: "22px",
                                cursor: "pointer",
                                zIndex: 2,
                                touchAction: "none",
                                backgroundColor: dynamicColor,
                              }}
                              onMouseDown={(e) => handleStartDrag(e, index)}
                              onTouchStart={(e) => handleStartDrag(e, index)}
                            ></div>

                            <div
                              className="slider-percentage-label"
                              style={{
                                position: "absolute",
                                left: `${sliderValue}%`,
                                top: "110%",
                                transform: "translateX(-50%)",
                                fontSize: "14px",
                                color: dynamicColor,
                                fontWeight: "900",
                                pointerEvents: "none",
                                zIndex: 3,
                              }}
                            >
                              {Math.round(percentFromCenter)}%
                            </div>
                          </div>

                          <div className="d-flex justify-content-between text-secondary test-name-points">
                            <span>Fully</span>
                            <span>Somewhat</span>
                            <span>Neutral</span>
                            <span>Somewhat</span>
                            <span>Fully</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestDetail;
